import React from "react";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { Button, FormControl, Grid, LinearProgress, TextField, Typography, useTheme, Link as MuiLink } from "@material-ui/core";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { generalFilter } from "../../../../util/filter";
import { useDownloadProjectFile } from "../../projectQueries";
import { useHistory } from "react-router";
import { ThreadedCreator } from "../../../common/threadedViewer/threadedCreator";
import { report } from "process";
import { stat } from "fs";
import { TechWriterDate } from "../reportWritersAgenda/TechWriterDate";
import Pagination from "@material-ui/lab/Pagination";
import { getTheme } from "../../../common/getLocalTheme";
import { ReportApproversTable } from "./ReportApproversTable";
import { useDeliveredHistory, useWriterHistory } from "../../../common/CommonQueries";
import { MovedApproverData } from "../reportWritersAgenda/MovedApproverData";
import { DeliveredData } from "./DeliveredData";
import moment from "moment";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import { toast } from "react-toastify";
import { useReportApprover } from "../../projectManagementQueries";


export const ReportApproversAgenda = () => {
    const theme = useTheme();
    const [page, setPage] = React.useState(1); // State for current page
    const itemsPerPage = 100;
    const [reportType, setReportType] = React.useState("");
    const [project_number, setProjectNumber] = React.useState('');
    const [customer, setCustomer] = React.useState('');
    const [author, setAuthor] = React.useState('');
    const [action, setAction] = React.useState(1);
    const [showDelivered, setShowDelivered] = React.useState(false);

    const { authAxios } = useFetchContext();


    const handleInputChangeReportType = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReportType(event.target.value);
    };
    const handleInputChangeProject = (event: React.ChangeEvent<HTMLInputElement>) => {
        setProjectNumber(event.target.value);
    };

    const handleInputChangeCustomer = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCustomer(event.target.value);
    };

    const handleInputChangeAuthor = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAuthor(event.target.value);
    };



    const {
        data: data,
        isLoading: isLoadingApproverReports,
        isError,
        error,
        refetch,
    } = useReportApprover(page == 1 ? 0 : (page - 1) * 10, itemsPerPage, action);

    const {
        data: approverData,
        isLoading: isLoadingApproverData,
        isError: isApproverError,
        refetch: refetchApproverData,
    } = useDeliveredHistory(showDelivered);

    const getDownloads = async (): Promise<any> => {
        if (data.count > 0) {
            const response = await authAxios.get(urls.reportApproversAgenda.approver_report_download, {
                responseType: 'blob'
            });



            const downloadUrl = URL.createObjectURL(response.data);
            let a = document.createElement("a");
            a.href = downloadUrl;
            a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
            document.body.appendChild(a);
            a.click();
        } else {
            toast.warning("No data found to download")
        }
    };


    if (isLoadingApproverReports) {
        return <LinearProgress />;
    }


    const handleButtonClickClear = () => {
        setPage(1)
        setReportType("")
        setProjectNumber("")
        setCustomer("")
        setAuthor("")
        setAction(action + 1)
        // queryClient.invalidateQueries(['module_inventory_data']);
    };

    const handleApproverdata = () => {
        setShowDelivered(prev => !prev);
    }

    return (
        <>
            <Typography variant="h2">Report Approver's Agenda</Typography>
            <div style={{ margin: 10, padding: 10 }}>

                <Grid item xs={12} alignItems="center" justifyContent="center">

                    {/* <FormControl style={{ marginLeft: '16px' }}  >
                        <TextField
                            label="Report Type"
                            variant="outlined"
                            value={reportType}
                            onChange={handleInputChangeReportType}
                        />
                    </FormControl>
                    <FormControl style={{ marginLeft: '16px' }}  >
                        <TextField
                            label="Project Number"
                            variant="outlined"
                            value={project_number}
                            onChange={handleInputChangeProject}
                        />
                    </FormControl>
                    <FormControl style={{ marginLeft: '16px' }}  >
                        <TextField
                            label="Customer"
                            variant="outlined"
                            value={customer}
                            onChange={handleInputChangeCustomer}
                        />
                    </FormControl>
                    <FormControl style={{ marginLeft: '16px' }}  >
                        <TextField
                            label="Author"
                            variant="outlined"
                            value={author}
                            onChange={handleInputChangeAuthor}
                        />
                    </FormControl>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: '16px', marginTop: '10px' }}
                    // onClick={handleButtonClick}
                    >
                        Search
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: '16px', marginTop: '10px' }}
                        onClick={handleButtonClickClear}
                    >
                        Clear
                    </Button> */}
                    <Grid container alignItems="center" spacing={1} style={{ marginTop: '10px' }}>
                        <Grid item>
                            <Typography variant="body1">Download Approver Report:</Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={getDownloads}
                            >
                                Download
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

            </div>

            <Grid item xs={12} style={{ marginBottom: 20 }}>
                <Pagination
                    count={Math.ceil(data.count / itemsPerPage)}
                    page={page}
                    onChange={(event, value) => {
                        console.log('Changing page to:', value);
                        setPage(value);
                        //   queryClient.invalidateQueries(['module_inventory_data']);
                    }}
                    variant="outlined"
                    color="primary"
                />
            </Grid>

            {data && (<ReportApproversTable data={data.results} refetch={refetch} ></ReportApproversTable>)}


            <Grid item xs={12} style={{ marginTop: 20 }}>
                <Pagination
                    count={Math.ceil(data.count / itemsPerPage)}
                    page={page}
                    onChange={(event, value) => {
                        console.log('Changing page to:', value);
                        setPage(value);
                        //   queryClient.invalidateQueries(['module_inventory_data']);
                    }}
                    variant="outlined"
                    color="primary"
                />
            </Grid>
            <Grid item xs={12} style={{ marginTop: "20px" }}>

                <MuiLink
                    component="button"
                    variant="body1"
                    onClick={handleApproverdata}
                    style={{ marginLeft: '16px', marginTop: '10px' }}
                >
                    {showDelivered ? "Hide Delivered Data" : "Show Delivered Data"}
                </MuiLink>
            </Grid>

            {showDelivered && (
                <>
                    {isLoadingApproverData && <LinearProgress />}
                    {isApproverError && <ErrorMessage message="Failed to load Approver Data" />}
                    {approverData && <DeliveredData data={approverData} refetch={refetchApproverData}/>}
                </>
            )}
        </>
    );
};
